import styled from "styled-components";

export const StandardToastTitleDefaultBox = styled.div`
    font-size: 1.6rem;
    color: ${props => props.theme.colors.brandPrimary};
    ${({theme}) => theme.font.presets.bold};
    line-height: 1.8rem;
    margin-block-end: 3px;
`;